import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../shared/Icons';
import { Button } from '../shared/Button';
import { notifyError, notifySuccess } from '../../lib/toast';

// One-tap copy for a redemption link an admin hands to an invitee. Shared by the Invites page
// and the platform-wide "add user" dialog — both show the signup URL exactly once, so both need
// the same fallback when the clipboard is unavailable.
export function CopyLink({ url }: { url: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
      notifySuccess(t('admin.copyLink.copiedToast'));
    } catch {
      // Clipboard can be blocked (insecure context); the input is selectable as a fallback.
      notifyError(t('admin.copyLink.copyFailedToast'));
    }
  }
  return (
    <div className="flex items-center gap-2">
      <input
        readOnly
        value={url}
        onFocus={(e) => e.currentTarget.select()}
        className="h-9 w-full rounded-sm border border-line-2 bg-bg px-2.5 font-mono text-[12px] text-ink-2"
      />
      <Button variant="default" size="sm" onClick={copy} className="flex-none">
        <Icon.copy className="w-3.5 h-3.5" />
        {copied ? t('admin.copyLink.copied') : t('admin.copyLink.copy')}
      </Button>
    </div>
  );
}
